import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PENDING_INVITATION_KEY } from 'src/utils/constants';

export const usePendingInvitation = () => {
  const [searchParams] = useSearchParams();
  const [invitationId, setInvitationId] = useState<string | null>(() =>
    sessionStorage.getItem(PENDING_INVITATION_KEY)
  );

  useEffect(() => {
    const stored = sessionStorage.getItem(PENDING_INVITATION_KEY);
    if (stored && stored !== invitationId) {
      setInvitationId(stored);
    }
  }, [searchParams, invitationId]);

  const clearPendingInvitation = useCallback(() => {
    sessionStorage.removeItem(PENDING_INVITATION_KEY);
    setInvitationId(null);
  }, []);

  return { invitationId, clearPendingInvitation };
};
